import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import our new guard and auth pages
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Import your existing pages
import DashboardPage from './pages/DashboardPage';
import ExpenseTrackerPage from './pages/ExpenseTrackerPage';
import PaymentsPage from './pages/PaymentsPage';
import CompanyProfilePage from './pages/CompanyProfilePage';
import ReportsPage from './pages/ReportsPage';

function App() {
  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* PROTECTED ROUTES */}
      {/* Any route wrapped in ProtectedRoute requires the user to be logged in. */}
      <Route 
        path="/" 
        element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} 
      />
      <Route 
        path="/project/:projectId" 
        element={<ProtectedRoute><ExpenseTrackerPage /></ProtectedRoute>} 
      />
      <Route 
        path="/project/:projectId/payments" 
        element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} 
      />
      <Route 
        path="/project/:projectId/reports" 
        element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} 
      />
      <Route 
        path="/profile" 
        element={<ProtectedRoute><CompanyProfilePage /></ProtectedRoute>} 
      />
    </Routes>
  );
}

export default App;